import BaseApiService from './BaseApiService';

class SubcategoryApiService extends BaseApiService {
    constructor() {
        super('subcategories');
    }

    async getAll() {
        const response = await this.request({ method: 'get', url: '' });
        return response && response.subcategories ? response.subcategories : [];
    }
}

export default new SubcategoryApiService();
